/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { popupControllerCreateV1 } from '../fn/popup/popup-controller-create-v-1';
import { PopupControllerCreateV1$Params } from '../fn/popup/popup-controller-create-v-1';
import { popupControllerDeleteV1 } from '../fn/popup/popup-controller-delete-v-1';
import { PopupControllerDeleteV1$Params } from '../fn/popup/popup-controller-delete-v-1';
import { popupControllerFindAllV1 } from '../fn/popup/popup-controller-find-all-v-1';
import { PopupControllerFindAllV1$Params } from '../fn/popup/popup-controller-find-all-v-1';
import { popupControllerFindByIdV1 } from '../fn/popup/popup-controller-find-by-id-v-1';
import { PopupControllerFindByIdV1$Params } from '../fn/popup/popup-controller-find-by-id-v-1';
import { popupControllerReorderV1 } from '../fn/popup/popup-controller-reorder-v-1';
import { PopupControllerReorderV1$Params } from '../fn/popup/popup-controller-reorder-v-1';
import { popupControllerSearchV1 } from '../fn/popup/popup-controller-search-v-1';
import { PopupControllerSearchV1$Params } from '../fn/popup/popup-controller-search-v-1';
import { popupControllerToggleExposedV1 } from '../fn/popup/popup-controller-toggle-exposed-v-1';
import { PopupControllerToggleExposedV1$Params } from '../fn/popup/popup-controller-toggle-exposed-v-1';
import { popupControllerUpdateV1 } from '../fn/popup/popup-controller-update-v-1';
import { PopupControllerUpdateV1$Params } from '../fn/popup/popup-controller-update-v-1';
import { PopupDto } from '../models/popup-dto';

@Injectable({ providedIn: 'root' })
export class PopupService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `popupControllerSearchV1()` */
  static readonly PopupControllerSearchV1Path = '/api/v1/popup/search';

  /**
   * Popup 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerSearchV1$Response(params?: PopupControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<PopupDto>;
}>> {
    return popupControllerSearchV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Popup 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerSearchV1(params?: PopupControllerSearchV1$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<PopupDto>;
}> {
    return this.popupControllerSearchV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<PopupDto>;
}>): OffsetPaginationDto & {
'items'?: Array<PopupDto>;
} => r.body)
    );
  }

  /** Path part for operation `popupControllerFindAllV1()` */
  static readonly PopupControllerFindAllV1Path = '/api/v1/popup';

  /**
   * 노출된 Popup 목록 조회 (최대 3개).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerFindAllV1$Response(params?: PopupControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PopupDto>>> {
    return popupControllerFindAllV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 노출된 Popup 목록 조회 (최대 3개).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerFindAllV1(params?: PopupControllerFindAllV1$Params, context?: HttpContext): Observable<Array<PopupDto>> {
    return this.popupControllerFindAllV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PopupDto>>): Array<PopupDto> => r.body)
    );
  }

  /** Path part for operation `popupControllerCreateV1()` */
  static readonly PopupControllerCreateV1Path = '/api/v1/popup';

  /**
   * Popup 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupControllerCreateV1$Response(params: PopupControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PopupDto>> {
    return popupControllerCreateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Popup 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupControllerCreateV1(params: PopupControllerCreateV1$Params, context?: HttpContext): Observable<PopupDto> {
    return this.popupControllerCreateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<PopupDto>): PopupDto => r.body)
    );
  }

  /** Path part for operation `popupControllerFindByIdV1()` */
  static readonly PopupControllerFindByIdV1Path = '/api/v1/popup/{id}';

  /**
   * Popup id로 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerFindByIdV1$Response(params: PopupControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PopupDto>> {
    return popupControllerFindByIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Popup id로 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerFindByIdV1(params: PopupControllerFindByIdV1$Params, context?: HttpContext): Observable<PopupDto> {
    return this.popupControllerFindByIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<PopupDto>): PopupDto => r.body)
    );
  }

  /** Path part for operation `popupControllerDeleteV1()` */
  static readonly PopupControllerDeleteV1Path = '/api/v1/popup/{id}';

  /**
   * Popup 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerDeleteV1$Response(params: PopupControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return popupControllerDeleteV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Popup 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerDeleteV1(params: PopupControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    return this.popupControllerDeleteV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `popupControllerUpdateV1()` */
  static readonly PopupControllerUpdateV1Path = '/api/v1/popup/{id}';

  /**
   * Popup 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupControllerUpdateV1$Response(params: PopupControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PopupDto>> {
    return popupControllerUpdateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Popup 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupControllerUpdateV1(params: PopupControllerUpdateV1$Params, context?: HttpContext): Observable<PopupDto> {
    return this.popupControllerUpdateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<PopupDto>): PopupDto => r.body)
    );
  }

  /** Path part for operation `popupControllerReorderV1()` */
  static readonly PopupControllerReorderV1Path = '/api/v1/popup/reorder';

  /**
   * 팝업 순서 변경.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerReorderV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupControllerReorderV1$Response(params: PopupControllerReorderV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return popupControllerReorderV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 팝업 순서 변경.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerReorderV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupControllerReorderV1(params: PopupControllerReorderV1$Params, context?: HttpContext): Observable<boolean> {
    return this.popupControllerReorderV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `popupControllerToggleExposedV1()` */
  static readonly PopupControllerToggleExposedV1Path = '/api/v1/popup/{id}/toggle-exposed';

  /**
   * Popup 노출 여부 토글.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerToggleExposedV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerToggleExposedV1$Response(params: PopupControllerToggleExposedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PopupDto>> {
    return popupControllerToggleExposedV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Popup 노출 여부 토글.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerToggleExposedV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerToggleExposedV1(params: PopupControllerToggleExposedV1$Params, context?: HttpContext): Observable<PopupDto> {
    return this.popupControllerToggleExposedV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<PopupDto>): PopupDto => r.body)
    );
  }

}
